var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Upload record config")]),_c('div',{staticClass:"upload-record-config__wrapper"},_vm._l((_vm.getCurrentFieldsByFileType),function(field){return _c('input-widget',{attrs:{"id":`inner-configurations-${field.name}`,"model":_vm.getCurrentModel,"field":field}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }